import { api, type AuthUser } from "./api";
import { writeActiveFamilyProfileId } from "./playerFamilyProfile";

/**
 * «Ver como jugador» desde CUALQUIER pantalla del admin: un solo camino
 * (Eduardo 2026-09-29). En una cuenta familiar el token es de la cuenta del
 * tutor, así que antes de entrar se deja como perfil activo al hijo que eligió
 * el admin. Sin esto la app abría con el hijo guardado antes en ese navegador
 * (o el primero de la cuenta) y el torneo mostraba otra credencial.
 */
export async function impersonatePlayer(
  token: string,
  playerProfileId: number,
  impersonateWithToken: (nextToken: string, nextUser: AuthUser) => void,
): Promise<void> {
  const response = await api.players.impersonate(token, playerProfileId);
  writeActiveFamilyProfileId(response.data.user.id, response.data.impersonation.player_profile_id);
  impersonateWithToken(response.data.access_token, response.data.user);
}
